/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './loader.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../app/loader/loader.component';
const styles_LoaderComponent:any[] = [i0.styles];
export const RenderType_LoaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoaderComponent,data:{}});
export function View_LoaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['Loading']))],(null as any),(null as any));
}
export function View_LoaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-loader',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoaderComponent_0,
      RenderType_LoaderComponent)),i1.ɵdid(1,114688,(null as any),0,i2.LoaderComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LoaderComponentNgFactory:i1.ComponentFactory<i2.LoaderComponent> = i1.ɵccf('app-loader',
    i2.LoaderComponent,View_LoaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvbG9hZGVyL2xvYWRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvQ2hyaXMvRG9jdW1lbnRzL1dlYkRldi9EZXZHZW5Bbmcvc3JjL2FwcC9sb2FkZXIvbG9hZGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvbG9hZGVyL2xvYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvbG9hZGVyL2xvYWRlci5jb21wb25lbnQudHMuTG9hZGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHA+TG9hZGluZzwvcD4iLCI8YXBwLWxvYWRlcj48L2FwcC1sb2FkZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQUc7YUFBQTs7O29CQ0FIO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/loader/loader.component.ngfactory.ts